import React, {useEffect, useState} from 'react';
import {Col, Row} from "react-bootstrap";
import Input from "../../../common/Input";
import {useDispatch, useSelector} from "react-redux";
import {
    resetTempNewWorkPermit,
    setNewWorkPermit,
    setTempNewWorkPermit
} from "../../../../_reducers/DataPanel/Payroll/payrollSlice";
import Dropdown from "../../../primer/Dropdown";
import EditableTable from "../../../primer/Editable-Table";
import {isEmpty} from "../../../../_helpers/commonFunctions";
import axios from "axios";
import TextArea from "../../../common/TextArea";
import {permitTypes} from "./Components/constants";
import moment from "moment";
import {setSaveNewWorkPermit} from "../../../../_reducers/activitySlice";
import useErganiInstallationOptions from "../../../../hooks/useErganiInstallationOptions";
import {useTranslation} from "../../../../hooks/useTranslation";

const NewWorkPermit = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const saveNewWorkPermit = useSelector((state) => state.ACTIVITY.saveNewWorkPermit);
    const workPermit = useSelector((state) => state.PAYROLL.newWorkPermit);
    const tempNewWorkPermit = useSelector((state) => state.PAYROLL.tempNewWorkPermit);
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const installationOptions = useErganiInstallationOptions(false);
    const [employeeList, setEmployeeList] = useState([]);

    const [incrKey, setIncrKey] = useState(0);

    const employeeColumns = [
        {
            label: "Όνομα",
            name: "firstName",
        },
        {
            label: "Επώνυμο",
            name: "lastName",
        },
        {
            label: "Α.Φ.Μ.",
            name: "vatNumber",
        },
    ]

    useEffect(() => {
        setIncrKey(incrKey + 1);
    }, [workPermit.employees, employeeList])

    useEffect(() => {
        loadEmployees(null, "empty", setEmployeeList);
    }, [])

    const loadEmployees = (cellName, keyword, setData) => {
        let reqData = {
            company: company.id,
            subAccountType: "employee",
            keyword: keyword,
        }
        axios.get(process.env.REACT_APP_API_URL2 + `/accounting/get-subAccount-by-word`, {
            params: reqData
        }).then(res => {
            if (res.data && res.data.status === '200') {
                if (res.data.data) {
                    if (setData) setData(res.data.data);
                } else {
                    if (setData) setData([]);
                }
            } else {
                if (setData) setData([]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const tableColumns = [
        {
            name: "Εργαζόμενος",
            field: "employeeIdentifier",
            editable: true,
            width: "30%",
            required: true,
            inputType: {
                config: {
                    excludeColumns: [],
                    columns: employeeColumns,
                    data: employeeList,
                    deleteEnable: false,
                    searchTableEnable: false,
                    showTableOptionOnSelect: true,
                    placeholder: "Επιλέξτε εργαζόμενο",
                    onChangeSearchCell: loadEmployees,
                    isPayrollCombobox: true
                },
                type: 'advanced-combobox',
            }
        },
        {
            name: "Τύπος Άδειας",
            field: "permitType",
            editable: true,
            width: "25%",
            inputType: {
                type: "select",
                options: permitTypes,
            }
        },
        {
            name: "Έτος αναφοράς",
            field: "erganiYear",
            editable: true,
            width: "15%",
            inputType: {
                type: "input",
                config: {
                    type: "number",
                }
            }
        },
        {
            name: "Ημερομηνία από",
            field: "dateFrom",
            editable: true,
            width: "15%",
            inputType: {
                type: "dayFormatDatebox",
                allowOtherYears: "true",
            }
        },
        {
            name: "Ημερομηνία μέχρι",
            field: "dateTo",
            editable: true,
            width: "15%",
            inputType: {
                type: "dayFormatDatebox",
                allowOtherYears: "true",
            }
        },
    ]

    const handleOnChange = (e, type, name) => {
        if (!saveNewWorkPermit) dispatch(setSaveNewWorkPermit(true));

        if (type === "input") {
            dispatch(setNewWorkPermit({...workPermit, [name] : e.target.value}));
        } else if (type === "dropdown") {
            dispatch(setNewWorkPermit({...workPermit, [name] : e.value}));
        }
    }

    const tableActions = {
        insert: (e, data) => {
            if (!saveNewWorkPermit) dispatch(setSaveNewWorkPermit(true));

            const cloneNewWorkPermit = structuredClone(tempNewWorkPermit);
            cloneNewWorkPermit.erganiYear = String(company.year);
            if (data.field === "employeeIdentifier") {
                cloneNewWorkPermit.employeeId = e.row._id;
                cloneNewWorkPermit.employeeIdentifier = `${e.row.firstName}|${e.row.lastName}|${e.row.vatNumber}`;
            } else if (data.field === "dateFrom") {
                if (moment(data.value).isValid()) {
                    cloneNewWorkPermit[data.field] = moment(data.value).format("DD/MM/YYYY");
                } else {
                    cloneNewWorkPermit[data.field] = "";
                }
            } else if (data.field === "dateTo") {
                if (moment(data.value).isValid()) {
                    cloneNewWorkPermit[data.field] = moment(data.value).format("DD/MM/YYYY");
                } else {
                    cloneNewWorkPermit[data.field] = "";
                }
            } else {
                cloneNewWorkPermit[data.field] = data.value;
            }
            if (!isEmpty(cloneNewWorkPermit.employeeId) && !isEmpty(cloneNewWorkPermit.employeeIdentifier) && !isEmpty(cloneNewWorkPermit.permitType) && !isEmpty(cloneNewWorkPermit.dateFrom) && !isEmpty(cloneNewWorkPermit.dateTo)) { // Insert
                let cloneEmployees = structuredClone(workPermit.employees);
                cloneEmployees.push(cloneNewWorkPermit);
                dispatch(setNewWorkPermit({...workPermit, employees: cloneEmployees}));
                dispatch(resetTempNewWorkPermit());
            } else { // Pre-insert row update
                dispatch(setTempNewWorkPermit(cloneNewWorkPermit));
            }
        },
        update: (data, id, rowIndex) => {
            if (!saveNewWorkPermit) dispatch(setSaveNewWorkPermit(true));

            let cloneEmployees = structuredClone(workPermit.employees);
            if (data?.employeeIdentifier?.row) {
                let tempCopy = structuredClone(data.employeeIdentifier.row);
                data.employeeId = tempCopy._id;
                data.employeeIdentifier = `${tempCopy.firstName}|${tempCopy.lastName}|${tempCopy.vatNumber}`;
            } else if (data.dateFrom) {
                data.dateFrom = moment(data.dateFrom).format("DD/MM/YYYY");
            } else if (data.dateTo) {
                data.dateTo = moment(data.dateTo).format("DD/MM/YYYY");
            }
            cloneEmployees[rowIndex] = {...cloneEmployees[rowIndex], ...data};
            dispatch(setNewWorkPermit({...workPermit, employees: cloneEmployees}));
        },
        selected: () => {},
        delete: (id, rowIndex) => {
            if (!saveNewWorkPermit) dispatch(setSaveNewWorkPermit(true));

            let cloneEmployees = structuredClone(workPermit.employees);
            cloneEmployees.splice(rowIndex, 1);
            dispatch(setNewWorkPermit({...workPermit, employees: cloneEmployees}));
        }
    }

    return (
        <React.Fragment>
            <Row className={"mb-2"}>
                <Col md={7}>
                    <Input
                        name={"description"}
                        label={"Περιγραφή"}
                        value={workPermit.description}
                        required={true}
                        onChange={(e) => handleOnChange(e, "input", "description")}
                        autoComplete={"off"}
                    />
                </Col>
                <Col md={5}>
                    <Dropdown
                        name={"installationMasterId"}
                        label={t("General.installation")}
                        options={installationOptions}
                        defaultValue={installationOptions.find((el) => el.value === workPermit.installationMasterId)}
                        key={Math.random()}
                        onChange={(e) => handleOnChange(e, "dropdown", "installationMasterId")}
                    />
                </Col>
            </Row>
            <Row className={"mb-2"}>
                <Col md={12}>
                    <div className={"text-muted mb-2"}><i>Άδειες</i></div>
                    <EditableTable
                        tableName={"New Work Permit Employees"}
                        key={incrKey}
                        data={workPermit.employees}
                        columns={tableColumns}
                        onUpdate={tableActions}
                        allowInsertRow={true}
                        allowActions={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <TextArea
                        name={"notes"}
                        label={"Σημειώσεις"}
                        rows={4}
                        value={workPermit.notes}
                        onChange={(e) => handleOnChange(e, "input", "notes")}
                        autoComplete={"off"}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default NewWorkPermit
